<div class="widget" *ngIf="!error">
    <div class="chart" echarts [options]="options" [loading]="loading" [merge]="options" *ngIf="!loading"></div>
    <div class="chart" *ngIf="loading">
        <div class="loading-spinner"></div>
    </div>
</div>

<div class="widget error" *ngIf="error">
    <app-error [error]="error"></app-error>
</div>